import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import * as ldTermActions from 'store/ld-terms/actions';
import { FormBody } from 'common/components/drawer';
import selectDataFromState from 'utils/selectDataFromState';
import moment from 'moment';

import config from './ld-term/config';
import LdTerm from './ld-term';

const EditLdTerms = ({ drawer, active, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateLdTerms, createLdTerms] = useActions([
    ldTermActions.updateLdTerms,
    ldTermActions.createLdTerms
  ]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { isOpen } = drawer;

  useEffect(() => {
    if (active && isOpen) {
      const params = {
        ...active,
        end_day: {
          id: active.end_day,
          label: moment().day(active.end_day).format('dddd')
        },
        start_day: {
          id: active.start_day,
          label: moment().day(active.start_day).format('dddd')
        }
      };

      const initialValues = selectDataFromState(params, config);

      loadValues({ ...initialValues });
    }

    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const { end_day, start_day, ...rest } = values;

    const params = {
      ...rest,
      end_day: end_day ? end_day.id : undefined,
      start_day: start_day ? start_day.id : undefined,
      id: active ? active.id : undefined,
      table: 'ld_terms'
    };

    setIsSubmitting(true);

    try {
      if (active) {
        const res = await updateLdTerms(params);

        if (res && !res.status) {
          drawer.close();
        } else {
          drawer.open();
        }
      } else {
        const res = await createLdTerms(params);

        if (res && !res.status) {
          drawer.close();
          resetForm();
          refetchData();
        } else {
          drawer.open();
        }
      }

      drawer.close();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Term'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <LdTerm formState={formState} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditLdTerms;
